// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/home.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../public/zona-1.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../public/zona-2.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../public/zona-3.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../public/zona-4.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../public/zona-5.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../public/bg-header.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* body {
  background-color: #ebdbbf!important;
} */
.header-container {
  display: flex;
    justify-content: space-between;
}

.description { text-align: center;}

.ps-collapsed {
  width: 50px !important;
  min-width: 50px !important;
}

.ps-menuitem-root>.ps-menu-button {
  padding-right: 5px !important;
padding-left: 5px  !important;
}

.page-title {
  color: #004C6C;
  padding-top: 15px;
  padding-bottom: 15px;
}

.filter-card {
  background-color: #509fbb29  !important;
  margin-top: 10px;
  margin-bottom: 10px;
  border: 0px solid transparent
}

small {
  color: #737675
}
.event-card .body span,
.facility-card .body span {
  font-size: 0.8em;
  color: #737675;
  text-overflow: ellipsis;
  width: 100%;
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
}

.event-card .body,
.facility-card .body {
  text-transform: capitalize;
}
/* .facility-card  .row{
  border: 3px solid #004C6C ;
} */
.event-card,
.facility-card  {
  background-color: #509fbb29 !important;
  border: 0px solid transparent  !important;
  overflow: hidden;
}
.event-card .body span.event-card-title, .event-card-title ,
.facility-card .body span.facility-card-title, .facility-card-title {
  font-size: 1em;
  font-weight: bold;
  color: #004C6C;
}
.hidden {
  display: none;
}


.react-form-wizard .wizard-icon-circle {
  width: 25px;
  height: 25px;
}
li.active .wizard-icon-container {
  background-color: #004C6C
}

li.active .stepTitle {
  color: #004C6C
}
li.active .ti-user {
  color: #ffffff
}

.react-form-wizard .wizard-navigation .wizard-progress-with-circle {
  position: relative;
  top: 16px;
  height: 4px;
  background: #f3f2ee;
}


form .form-field {
  position: relative;
  margin: 0px 0 16px;
}
form select,
form input {
  display: block;
  width: 100%;
  height: 36px;
  border-width: 0 0 2px 0 !important;
  border-color: #a9a9a9;
  font-size: 18px;
  line-height: 26px;
  font-weight: 400;
}
form input:focus {
  outline: none;
}
/* form input:focus ~ .form-label,
form input.not-empty ~ .form-label {
  -webkit-transform: translateY(24px);
          transform: translateY(24px);
}

form input:focus + .form-label.date,
form input.not-empty + .form-label.date {
  -webkit-transform: translateY(24px)  translateX(30px);
          transform: translateY(24px)  translateX(30px);
}
form input.is-invalid + .form-label {
  right: 32px;
}
form  input.is-invalid + .form-label.date {
  right: 60px;
}
form input.is-invalid:focus + .form-label {
  right: 3px;
  top: auto;
} */
form .form-label {
  position: absolute;
  right: 3px;
  bottom: -3px;
  top: 7px;
  font-size: 0.875em;
  line-height: 26px;
  font-weight: 400;
  color: grey;
  cursor: text;
  transition: transform .2s ease-in-out;
}
form input.is-invalid ~ .form-label {
  right: 32px;
} 
form input.is-invalid ~ .form-label.date {
  right: 62px;
} 
form .form-label.number,
form .form-label.date {
  right: 35px;
}
form .submit-btn {
  display: inline-block;
  background-color: #000;
   background-image: linear-gradient(125deg,#a72879,#064497);
  color: #fff;
  text-transform: uppercase;
  letter-spacing: 2px;
  font-size: 16px;
  padding: 8px 16px;
  border: none;
  width:200px;
  cursor: pointer;
}


.form-control:focus {
  box-shadow: 0 -3px 10px .25rem  rgba(0, 148, 141, 0.25);
}


.modal-body .d-flex > .form-field {
  margin-bottom: 0px !important;
}

select:disabled {
  appearance: none; /* Nasconde la freccetta su Firefox e Safari */
  -moz-appearance: none; /* Nasconde la freccetta su Firefox */
  -webkit-appearance: none; /* Nasconde la freccetta su Safari e Chrome */
  background: none; /* Rimuove lo sfondo che potrebbe contenere la freccetta */
}
/* Specifica un'altezza minima per il select in modo che non collassi */
select:disabled::after {
  content: '\\00a0'; /* Aggiungi uno spazio non interrompibile per mantenere l'altezza */
}


select.form-select {
  appearance: none; /* Nasconde la freccetta su Firefox e Safari */
  -moz-appearance: none; /* Nasconde la freccetta su Firefox */
  -webkit-appearance: none; /* Nasconde la freccetta su Safari e Chrome */
  background: none; /* Rimuove lo sfondo che potrebbe contenere la freccetta */
}
/* Specifica un'altezza minima per il select in modo che non collassi */
select.form-select::after {
  content: '\\00a0'; /* Aggiungi uno spazio non interrompibile per mantenere l'altezza */
}

.btn-primary {
  color: #ffffff !important;
}


.carousel-list  {
  padding-top: 50px !important;
}
.carousel-list:before {
  content: " ";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 150px;
  width: 100%;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: contain;
  z-index: 100;
}

.zone-1:after,
.zone-2:after,
.zone-3:after,
.zone-5:after,
.zone-4:after {
  content: " ";
  background-size: cover;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 150px;
}
.zone-1:after { 
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: cover;
}
.zone-2:after { 
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-size: cover;
}
.zone-3:after { 
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-size: cover;
}
.zone-4:after { 
  background: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-size: cover;
}
.zone-5:after { 
  background: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  background-size: cover;
}


.form-select.is-invalid {
background-image: none !important;
}




.navbar-collapse li a {
  font-weight: bolder !important;
  color: #ffffff !important;
  padding: 2px 18px !important;
  text-decoration: none;
  text-transform: uppercase;  
}

.x-to-close { display: none; }
.navbar-toggler {
  background: white !important;
}

.navbar-brand img { 
  width: 220px !important;
}

@media screen and (max-width: 992px) {
  .x-to-close { display: block; 
    position: absolute;
    right: -53px;
    padding: 20px;
    top: 0;
    background: #004C6C;
    color: #ffffff;
  }
  .navbar-collapse {
    position: absolute;
    top: 0px;
    background: #004C6C;
    left: 0px;
    padding: 2rem 10px;
    min-height: 100vh;
    border-right: 2px solid #004C6C ;
  }
  .navbar-collapse li a {
    background: transparent;
    padding: 20px 50px 20px 40px !important;
    font-size: 16px;
    display: inline-block;
    width: 100%;
  }

  .navbar-collapse li a .nav li a {
  padding: 10px 50px 10px 40px !important;
  font-weight: 400;
}

  .navbar-toggler {
    order: 1;
  }
  .navbar-brand {
    order: 2;
    margin-left: 0.5rem;
    margin-right: 0.5rem !important;
    flex-grow: 2;
    max-width: 55%;
  }
  .dropdown  {
    order: 3;
  }


  .navbar-toggler-icon {
    width: 1em !important;
    height: 1em !important;
  }
}

@media screen and (max-width: 576px) {
  .navbar-brand img {
    max-width: 100%;
    width: auto !important;
  }
}


.navbar-toggler {
  border: 0px solid transparent;
}

.border-gradient {
  border: 10px solid;
  border-image-slice: 1;
  border-width: 5px;
  border-image-source: linear-gradient(to left, #53b8e2, #004C6C);
  border-left: 0;
  border-right: 0;
  border-top: 0;
}



.categories-banner-inner {
  position: relative;
  overflow: hidden;
}
.categories-banner-inner:before {
  content: '';
  left: 0;
  top: 0;
  width: 100%;
  height: 50%;
  background-image: linear-gradient(to bottom, #323031 0%, transparent 100%);
  background-repeat: repeat-x;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#FF323031', endColorstr='#00000000', GradientType=0);
  position: absolute;
  transition: all 0.2s ease-in-out 0s;
  opacity: 1;
  filter: alpha(opacity=100);
}
.categories-banner-inner:after {
  width: 100%;
  height: 100%;
  position: absolute;
  background: #323031;
  transition: all 0.2s ease-in-out 0s;
  top: 0;
  left: 0;
  opacity: 0;
  filter: alpha(opacity=0);
  content: '';
}
.categories-banner-inner.style2:before {
  width: 100%;
  height: 100%;
  background: #252c41;
  opacity: 0.7;
  filter: alpha(opacity=70);
}
.categories-banner-inner.style2:after {
  background-color: #28b8dc;
  background-image: radial-gradient(farthest-corner at 0% 100%, #fb3640 0%, #28b8dc 100%);
  background-image: -webkit-radial-gradient(farthest-corner at 0% 100%, #fb3640 0%, #28b8dc 100%);
  background-repeat: repeat-x;
}
.categories-banner-inner.style2 .category-icon {
  bottom: inherit;
  top: 20px;
  right: 20px;
}
.rtl .categories-banner-inner.style2 .category-icon {
  left: 20px;
  right: auto;
}
@media (min-width: 992px) {
  .categories-banner-inner.style2 .category-icon {
    top: 30px;
    right: 30px;
  }
  .rtl .categories-banner-inner.style2 .category-icon {
    left: 30px;
    right: auto;
  }
}
.categories-banner-inner.style2 .content-inner {
  text-align: left;
  top: inherit;
  bottom: 20px;
  left: 20px;
}
.rtl .categories-banner-inner.style2 .content-inner {
  right: 20px;
  left: auto;
}
@media (min-width: 992px) {
  .categories-banner-inner.style2 .content-inner {
    bottom: 30px;
    left: 30px;
  }
  .rtl .categories-banner-inner.style2 .content-inner {
    right: 30px;
    left: auto;
  }
}
.categories-banner-inner .content-inner {
  position: absolute;
  top: 30px;
  left: 40px;
  z-index: 2;
}
.rtl .categories-banner-inner .content-inner {
  right: 40px;
  left: auto;
}
.categories-banner-inner .category-icon {
  position: absolute;
  bottom: 20px;
  right: 20px;
  z-index: 2;
}
.rtl .categories-banner-inner .category-icon {
  left: 20px;
  right: auto;
}
@media (min-width: 768px) {
  .categories-banner-inner .category-icon {
    bottom: 30px;
    right: 30px;
  }
  .rtl .categories-banner-inner .category-icon {
    left: 30px;
    right: auto;
  }
}
.categories-banner-inner .category-info-title {
  font-size: 25px;
  margin: 0 0 5px;
  color: #fff;
}
.categories-banner-inner .category-number {
  color: #fff;
  text-transform: capitalize;
  font-size: 15px;
}
.categories-banner-inner:active:before, .categories-banner-inner:hover:before {
  opacity: 0;
  filter: alpha(opacity=0);
}
.categories-banner-inner:active:after, .categories-banner-inner:hover:after {
  opacity: 0.6;
  filter: alpha(opacity=60);
}


.form-check-input {
  float: left;
  margin-right: 10px;
  background-color: #8080800a;
}
label.checkbox.form-label {
  position: static;
}

.form-select {
  padding-right: 12px;
}


.mr-2 {
  margin-right: 10px;
}
.mlat-2 {
  margin-right: 10px;
  margin-left: 10px;
}


.react-form-wizard {
  padding-bottom: 0;
}

li.active .wizard-icon-container {
  background-color: #53b8e2;
}
li.active.current .wizard-icon-container {
  background-color: #004C6C
}
.floating {
  position: absolute;
  left: 8px;
  border-radius: 5px;
  top: 0;
  width: 33px !important;
  line-height: 92px;
  bottom: 12px;
  font-size: 2rem;
  text-align: center;
  background: #53b8e2;
  color: white;
  padding: 0 !important;
}
.row.primo {
  padding-left: 50px;
  position: relative;
}

.invalid-feedback.show {
  display: block !important;
}

.navbar { 
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  background-repeat: repeat-y;
  background-size: contain;
}

.lightblu {
  color: #53b8e2;
}
.lightblu-contrast {
  color: #53b8e2;
  text-shadow: 0px 0px 1px #164d6c4f;
}
.body span {
  text-overflow: 'ellipsis';
  width: '100%';
  display: 'inline-block';
  overflow: 'hidden';
  white-space: 'nowrap';
}


.carousel-item p {
  font-weight: 300;
  line-height: 2rem;
  font-size: 1.8em;
}
.carousel-item h5 {
  color: #fff;
  font-size: 45px;
  font-weight: 700;
  margin: 0;
  text-align: center;
}
.carousel-item {
  max-height: 400px;
}


.navbar-nav .nav-link {
  background: #154c6b8a;
  border-radius: 5px;
  margin: 0 2px;
}

.widget-text-heading {
  text-shadow: 3px 3px 5px rgba(0, 0, 0, 0.7);
}
.home-col {
  margin-bottom: 3rem;
  line-height: 1.5rem;
}


@media (min-width: 992px) {
  .home-col {
    width: 30%;
  }
}

.react-calendar__tile--now {
  background: #e5f0f4;
}

.rows_count {
  line-height: 2.2rem;
  color: #737675;
}

.locality-info{
  display: flex;
  gap: 4rem;
   
}

.locality-container{
  margin-top: 20px;
  color: #3e6791;
  padding-left: 8rem;
  padding-right: 8rem;
  margin-left: 10%;
  margin-right: 10%;   
}

.circleItem{
  background: lightblue;
  border-radius: 50%;
  width: 25px;
  height: 25px;
  vertical-align: middle;
}

.cubeItem{
  background: lightblue;
  width: 25px;
  height: 25px;
  vertical-align: middle;
}

.inner-locality-info{
   display: flex; 
  flex-direction: column;
  align-items: flex-start; 
  width: "50%";
}


@media (max-width: 768px) {
  .locality-info {
    flex-direction: column;
    align-items: center;
    text-align: center; 
  }

  .locality-container{
    margin-top: 20px;
    color: #3e6791;
    padding-left: 0rem;
    padding-right: 0rem;
    margin-left: 0%;
    margin-right: 0%;   
  }

  .inner-locality-info{
    display: flex; 
   flex-direction: column;
   align-items: flex-start; 
   width: "80%";
   padding: 0 20px 0 20px;
 }

  .image-locality{
    width: 100%;
    object-fit: contain;
  }

}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;GAEG;AACH;EACE,aAAa;IACX,8BAA8B;AAClC;;AAEA,eAAe,kBAAkB,CAAC;;AAElC;EACE,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;AAC/B,6BAA6B;AAC7B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;EAChB,mBAAmB;EACnB;AACF;;AAEA;EACE;AACF;AACA;;EAEE,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,WAAW;EACX,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,0BAA0B;AAC5B;AACA;;GAEG;AACH;;EAEE,sCAAsC;EACtC,yCAAyC;EACzC,gBAAgB;AAClB;AACA;;EAEE,cAAc;EACd,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,aAAa;AACf;;;AAGA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE;AACF;;AAEA;EACE;AACF;AACA;EACE;AACF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,mBAAmB;AACrB;;;AAGA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;;EAEE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;;;;;;;;;;;;;;;;;;;;GAoBG;AACH;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,QAAQ;EACR,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,YAAY;EAEZ,qCAAqC;AAGvC;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;;EAEE,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,sBAAsB;GACrB,yDAAyD;EAC1D,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;;;AAGA;EACE,uDAAuD;AACzD;;;AAGA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB,EAAE,8CAA8C;EAChE,qBAAqB,EAAE,qCAAqC;EAC5D,wBAAwB,EAAE,6CAA6C;EACvE,gBAAgB,EAAE,0DAA0D;AAC9E;AACA,uEAAuE;AACvE;EACE,gBAAgB,EAAE,mEAAmE;AACvF;;;AAGA;EACE,gBAAgB,EAAE,8CAA8C;EAChE,qBAAqB,EAAE,qCAAqC;EAC5D,wBAAwB,EAAE,6CAA6C;EACvE,gBAAgB,EAAE,0DAA0D;AAC9E;AACA,uEAAuE;AACvE;EACE,gBAAgB,EAAE,mEAAmE;AACvF;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,4BAA4B;AAC9B;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,aAAa;EACb,WAAW;EACX,mDAAqC;EACrC,wBAAwB;EACxB,YAAY;AACd;;AAEA;;;;;EAKE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,aAAa;AACf;AACA;EACE,mDAAuC;EACvC,sBAAsB;AACxB;AACA;EACE,mDAAuC;EACvC,sBAAsB;AACxB;AACA;EACE,mDAAuC;EACvC,sBAAsB;AACxB;AACA;EACE,mDAAuC;EACvC,sBAAsB;AACxB;AACA;EACE,mDAAuC;EACvC,sBAAsB;AACxB;;;AAGA;AACA,iCAAiC;AACjC;;;;;AAKA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,4BAA4B;EAC5B,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA,cAAc,aAAa,EAAE;AAC7B;EACE,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc,cAAc;IAC1B,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,MAAM;IACN,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,kBAAkB;IAClB,QAAQ;IACR,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,iBAAiB;IACjB,gCAAgC;EAClC;EACA;IACE,uBAAuB;IACvB,uCAAuC;IACvC,eAAe;IACf,qBAAqB;IACrB,WAAW;EACb;;EAEA;EACA,uCAAuC;EACvC,gBAAgB;AAClB;;EAEE;IACE,QAAQ;EACV;EACA;IACE,QAAQ;IACR,mBAAmB;IACnB,+BAA+B;IAC/B,YAAY;IACZ,cAAc;EAChB;EACA;IACE,QAAQ;EACV;;;EAGA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,eAAe;IACf,sBAAsB;EACxB;AACF;;;AAGA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,+DAA+D;EAC/D,cAAc;EACd,eAAe;EACf,aAAa;AACf;;;;AAIA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,OAAO;EACP,MAAM;EACN,WAAW;EACX,WAAW;EAGX,0EAA0E;EAC1E,2BAA2B;EAC3B,sHAAsH;EACtH,kBAAkB;EAGlB,mCAAmC;EACnC,UAAU;EACV,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EAGnB,mCAAmC;EACnC,MAAM;EACN,OAAO;EACP,UAAU;EACV,wBAAwB;EACxB,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,uFAAuF;EACvF,+FAA+F;EAC/F,2BAA2B;AAC7B;AACA;EACE,eAAe;EACf,SAAS;EACT,WAAW;AACb;AACA;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE;IACE,SAAS;IACT,WAAW;EACb;EACA;IACE,UAAU;IACV,WAAW;EACb;AACF;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,UAAU;AACZ;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE;IACE,YAAY;IACZ,UAAU;EACZ;EACA;IACE,WAAW;IACX,UAAU;EACZ;AACF;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,UAAU;AACZ;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,UAAU;AACZ;AACA;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,UAAU;IACV,WAAW;EACb;AACF;AACA;EACE,eAAe;EACf,eAAe;EACf,WAAW;AACb;AACA;EACE,WAAW;EACX,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,UAAU;EACV,wBAAwB;AAC1B;AACA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;;AAGA;EACE,WAAW;EACX,kBAAkB;EAClB,2BAA2B;AAC7B;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;;AAGA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;;AAGA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE;AACF;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,MAAM;EACN,sBAAsB;EACtB,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yDAAgD;EAChD,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,kCAAkC;AACpC;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,qBAAqB;AACvB;;;AAGA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;;;AAGA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,2CAA2C;AAC7C;AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;;AAGA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;;AAEX;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;GACG,aAAa;EACd,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;AACd;;;AAGA;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,aAAa;GACd,sBAAsB;GACtB,uBAAuB;GACvB,YAAY;GACZ,sBAAsB;CACxB;;EAEC;IACE,WAAW;IACX,mBAAmB;EACrB;;AAEF","sourcesContent":["/* body {\n  background-color: #ebdbbf!important;\n} */\n.header-container {\n  display: flex;\n    justify-content: space-between;\n}\n\n.description { text-align: center;}\n\n.ps-collapsed {\n  width: 50px !important;\n  min-width: 50px !important;\n}\n\n.ps-menuitem-root>.ps-menu-button {\n  padding-right: 5px !important;\npadding-left: 5px  !important;\n}\n\n.page-title {\n  color: #004C6C;\n  padding-top: 15px;\n  padding-bottom: 15px;\n}\n\n.filter-card {\n  background-color: #509fbb29  !important;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  border: 0px solid transparent\n}\n\nsmall {\n  color: #737675\n}\n.event-card .body span,\n.facility-card .body span {\n  font-size: 0.8em;\n  color: #737675;\n  text-overflow: ellipsis;\n  width: 100%;\n  display: inline-block;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.event-card .body,\n.facility-card .body {\n  text-transform: capitalize;\n}\n/* .facility-card  .row{\n  border: 3px solid #004C6C ;\n} */\n.event-card,\n.facility-card  {\n  background-color: #509fbb29 !important;\n  border: 0px solid transparent  !important;\n  overflow: hidden;\n}\n.event-card .body span.event-card-title, .event-card-title ,\n.facility-card .body span.facility-card-title, .facility-card-title {\n  font-size: 1em;\n  font-weight: bold;\n  color: #004C6C;\n}\n.hidden {\n  display: none;\n}\n\n\n.react-form-wizard .wizard-icon-circle {\n  width: 25px;\n  height: 25px;\n}\nli.active .wizard-icon-container {\n  background-color: #004C6C\n}\n\nli.active .stepTitle {\n  color: #004C6C\n}\nli.active .ti-user {\n  color: #ffffff\n}\n\n.react-form-wizard .wizard-navigation .wizard-progress-with-circle {\n  position: relative;\n  top: 16px;\n  height: 4px;\n  background: #f3f2ee;\n}\n\n\nform .form-field {\n  position: relative;\n  margin: 0px 0 16px;\n}\nform select,\nform input {\n  display: block;\n  width: 100%;\n  height: 36px;\n  border-width: 0 0 2px 0 !important;\n  border-color: #a9a9a9;\n  font-size: 18px;\n  line-height: 26px;\n  font-weight: 400;\n}\nform input:focus {\n  outline: none;\n}\n/* form input:focus ~ .form-label,\nform input.not-empty ~ .form-label {\n  -webkit-transform: translateY(24px);\n          transform: translateY(24px);\n}\n\nform input:focus + .form-label.date,\nform input.not-empty + .form-label.date {\n  -webkit-transform: translateY(24px)  translateX(30px);\n          transform: translateY(24px)  translateX(30px);\n}\nform input.is-invalid + .form-label {\n  right: 32px;\n}\nform  input.is-invalid + .form-label.date {\n  right: 60px;\n}\nform input.is-invalid:focus + .form-label {\n  right: 3px;\n  top: auto;\n} */\nform .form-label {\n  position: absolute;\n  right: 3px;\n  bottom: -3px;\n  top: 7px;\n  font-size: 0.875em;\n  line-height: 26px;\n  font-weight: 400;\n  color: grey;\n  cursor: text;\n  transition: -webkit-transform .2s ease-in-out;\n  transition: transform .2s ease-in-out;\n  transition: transform .2s ease-in-out, \n  -webkit-transform .2s ease-in-out;\n}\nform input.is-invalid ~ .form-label {\n  right: 32px;\n} \nform input.is-invalid ~ .form-label.date {\n  right: 62px;\n} \nform .form-label.number,\nform .form-label.date {\n  right: 35px;\n}\nform .submit-btn {\n  display: inline-block;\n  background-color: #000;\n   background-image: linear-gradient(125deg,#a72879,#064497);\n  color: #fff;\n  text-transform: uppercase;\n  letter-spacing: 2px;\n  font-size: 16px;\n  padding: 8px 16px;\n  border: none;\n  width:200px;\n  cursor: pointer;\n}\n\n\n.form-control:focus {\n  box-shadow: 0 -3px 10px .25rem  rgba(0, 148, 141, 0.25);\n}\n\n\n.modal-body .d-flex > .form-field {\n  margin-bottom: 0px !important;\n}\n\nselect:disabled {\n  appearance: none; /* Nasconde la freccetta su Firefox e Safari */\n  -moz-appearance: none; /* Nasconde la freccetta su Firefox */\n  -webkit-appearance: none; /* Nasconde la freccetta su Safari e Chrome */\n  background: none; /* Rimuove lo sfondo che potrebbe contenere la freccetta */\n}\n/* Specifica un'altezza minima per il select in modo che non collassi */\nselect:disabled::after {\n  content: '\\00a0'; /* Aggiungi uno spazio non interrompibile per mantenere l'altezza */\n}\n\n\nselect.form-select {\n  appearance: none; /* Nasconde la freccetta su Firefox e Safari */\n  -moz-appearance: none; /* Nasconde la freccetta su Firefox */\n  -webkit-appearance: none; /* Nasconde la freccetta su Safari e Chrome */\n  background: none; /* Rimuove lo sfondo che potrebbe contenere la freccetta */\n}\n/* Specifica un'altezza minima per il select in modo che non collassi */\nselect.form-select::after {\n  content: '\\00a0'; /* Aggiungi uno spazio non interrompibile per mantenere l'altezza */\n}\n\n.btn-primary {\n  color: #ffffff !important;\n}\n\n\n.carousel-list  {\n  padding-top: 50px !important;\n}\n.carousel-list:before {\n  content: \" \";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 150px;\n  width: 100%;\n  background: url('../public/home.png');\n  background-size: contain;\n  z-index: 100;\n}\n\n.zone-1:after,\n.zone-2:after,\n.zone-3:after,\n.zone-5:after,\n.zone-4:after {\n  content: \" \";\n  background-size: cover;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 150px;\n}\n.zone-1:after { \n  background: url('../public/zona-1.png');\n  background-size: cover;\n}\n.zone-2:after { \n  background: url('../public/zona-2.png');\n  background-size: cover;\n}\n.zone-3:after { \n  background: url('../public/zona-3.png');\n  background-size: cover;\n}\n.zone-4:after { \n  background: url('../public/zona-4.png');\n  background-size: cover;\n}\n.zone-5:after { \n  background: url('../public/zona-5.png');\n  background-size: cover;\n}\n\n\n.form-select.is-invalid {\nbackground-image: none !important;\n}\n\n\n\n\n.navbar-collapse li a {\n  font-weight: bolder !important;\n  color: #ffffff !important;\n  padding: 2px 18px !important;\n  text-decoration: none;\n  text-transform: uppercase;  \n}\n\n.x-to-close { display: none; }\n.navbar-toggler {\n  background: white !important;\n}\n\n.navbar-brand img { \n  width: 220px !important;\n}\n\n@media screen and (max-width: 992px) {\n  .x-to-close { display: block; \n    position: absolute;\n    right: -53px;\n    padding: 20px;\n    top: 0;\n    background: #004C6C;\n    color: #ffffff;\n  }\n  .navbar-collapse {\n    position: absolute;\n    top: 0px;\n    background: #004C6C;\n    left: 0px;\n    padding: 2rem 10px;\n    min-height: 100vh;\n    border-right: 2px solid #004C6C ;\n  }\n  .navbar-collapse li a {\n    background: transparent;\n    padding: 20px 50px 20px 40px !important;\n    font-size: 16px;\n    display: inline-block;\n    width: 100%;\n  }\n\n  .navbar-collapse li a .nav li a {\n  padding: 10px 50px 10px 40px !important;\n  font-weight: 400;\n}\n\n  .navbar-toggler {\n    order: 1;\n  }\n  .navbar-brand {\n    order: 2;\n    margin-left: 0.5rem;\n    margin-right: 0.5rem !important;\n    flex-grow: 2;\n    max-width: 55%;\n  }\n  .dropdown  {\n    order: 3;\n  }\n\n\n  .navbar-toggler-icon {\n    width: 1em !important;\n    height: 1em !important;\n  }\n}\n\n@media screen and (max-width: 576px) {\n  .navbar-brand img {\n    max-width: 100%;\n    width: auto !important;\n  }\n}\n\n\n.navbar-toggler {\n  border: 0px solid transparent;\n}\n\n.border-gradient {\n  border: 10px solid;\n  border-image-slice: 1;\n  border-width: 5px;\n  border-image-source: linear-gradient(to left, #53b8e2, #004C6C);\n  border-left: 0;\n  border-right: 0;\n  border-top: 0;\n}\n\n\n\n.categories-banner-inner {\n  position: relative;\n  overflow: hidden;\n}\n.categories-banner-inner:before {\n  content: '';\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 50%;\n  background-image: -webkit-linear-gradient(top, #323031 0%, transparent 100%);\n  background-image: -o-linear-gradient(top, #323031 0%, transparent 100%);\n  background-image: linear-gradient(to bottom, #323031 0%, transparent 100%);\n  background-repeat: repeat-x;\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#FF323031', endColorstr='#00000000', GradientType=0);\n  position: absolute;\n  -webkit-transition: all 0.2s ease-in-out 0s;\n  -o-transition: all 0.2s ease-in-out 0s;\n  transition: all 0.2s ease-in-out 0s;\n  opacity: 1;\n  filter: alpha(opacity=100);\n}\n.categories-banner-inner:after {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  background: #323031;\n  -webkit-transition: all 0.2s ease-in-out 0s;\n  -o-transition: all 0.2s ease-in-out 0s;\n  transition: all 0.2s ease-in-out 0s;\n  top: 0;\n  left: 0;\n  opacity: 0;\n  filter: alpha(opacity=0);\n  content: '';\n}\n.categories-banner-inner.style2:before {\n  width: 100%;\n  height: 100%;\n  background: #252c41;\n  opacity: 0.7;\n  filter: alpha(opacity=70);\n}\n.categories-banner-inner.style2:after {\n  background-color: #28b8dc;\n  background-image: radial-gradient(farthest-corner at 0% 100%, #fb3640 0%, #28b8dc 100%);\n  background-image: -webkit-radial-gradient(farthest-corner at 0% 100%, #fb3640 0%, #28b8dc 100%);\n  background-repeat: repeat-x;\n}\n.categories-banner-inner.style2 .category-icon {\n  bottom: inherit;\n  top: 20px;\n  right: 20px;\n}\n.rtl .categories-banner-inner.style2 .category-icon {\n  left: 20px;\n  right: auto;\n}\n@media (min-width: 992px) {\n  .categories-banner-inner.style2 .category-icon {\n    top: 30px;\n    right: 30px;\n  }\n  .rtl .categories-banner-inner.style2 .category-icon {\n    left: 30px;\n    right: auto;\n  }\n}\n.categories-banner-inner.style2 .content-inner {\n  text-align: left;\n  top: inherit;\n  bottom: 20px;\n  left: 20px;\n}\n.rtl .categories-banner-inner.style2 .content-inner {\n  right: 20px;\n  left: auto;\n}\n@media (min-width: 992px) {\n  .categories-banner-inner.style2 .content-inner {\n    bottom: 30px;\n    left: 30px;\n  }\n  .rtl .categories-banner-inner.style2 .content-inner {\n    right: 30px;\n    left: auto;\n  }\n}\n.categories-banner-inner .content-inner {\n  position: absolute;\n  top: 30px;\n  left: 40px;\n  z-index: 2;\n}\n.rtl .categories-banner-inner .content-inner {\n  right: 40px;\n  left: auto;\n}\n.categories-banner-inner .category-icon {\n  position: absolute;\n  bottom: 20px;\n  right: 20px;\n  z-index: 2;\n}\n.rtl .categories-banner-inner .category-icon {\n  left: 20px;\n  right: auto;\n}\n@media (min-width: 768px) {\n  .categories-banner-inner .category-icon {\n    bottom: 30px;\n    right: 30px;\n  }\n  .rtl .categories-banner-inner .category-icon {\n    left: 30px;\n    right: auto;\n  }\n}\n.categories-banner-inner .category-info-title {\n  font-size: 25px;\n  margin: 0 0 5px;\n  color: #fff;\n}\n.categories-banner-inner .category-number {\n  color: #fff;\n  text-transform: capitalize;\n  font-size: 15px;\n}\n.categories-banner-inner:active:before, .categories-banner-inner:hover:before {\n  opacity: 0;\n  filter: alpha(opacity=0);\n}\n.categories-banner-inner:active:after, .categories-banner-inner:hover:after {\n  opacity: 0.6;\n  filter: alpha(opacity=60);\n}\n\n\n.form-check-input {\n  float: left;\n  margin-right: 10px;\n  background-color: #8080800a;\n}\nlabel.checkbox.form-label {\n  position: static;\n}\n\n.form-select {\n  padding-right: 12px;\n}\n\n\n.mr-2 {\n  margin-right: 10px;\n}\n.mlat-2 {\n  margin-right: 10px;\n  margin-left: 10px;\n}\n\n\n.react-form-wizard {\n  padding-bottom: 0;\n}\n\nli.active .wizard-icon-container {\n  background-color: #53b8e2;\n}\nli.active.current .wizard-icon-container {\n  background-color: #004C6C\n}\n.floating {\n  position: absolute;\n  left: 8px;\n  border-radius: 5px;\n  top: 0;\n  width: 33px !important;\n  line-height: 92px;\n  bottom: 12px;\n  font-size: 2rem;\n  text-align: center;\n  background: #53b8e2;\n  color: white;\n  padding: 0 !important;\n}\n.row.primo {\n  padding-left: 50px;\n  position: relative;\n}\n\n.invalid-feedback.show {\n  display: block !important;\n}\n\n.navbar { \n  background-image: url('../public/bg-header.png');\n  background-repeat: repeat-y;\n  background-size: contain;\n}\n\n.lightblu {\n  color: #53b8e2;\n}\n.lightblu-contrast {\n  color: #53b8e2;\n  text-shadow: 0px 0px 1px #164d6c4f;\n}\n.body span {\n  text-overflow: 'ellipsis';\n  width: '100%';\n  display: 'inline-block';\n  overflow: 'hidden';\n  white-space: 'nowrap';\n}\n\n\n.carousel-item p {\n  font-weight: 300;\n  line-height: 2rem;\n  font-size: 1.8em;\n}\n.carousel-item h5 {\n  color: #fff;\n  font-size: 45px;\n  font-weight: 700;\n  margin: 0;\n  text-align: center;\n}\n.carousel-item {\n  max-height: 400px;\n}\n\n\n.navbar-nav .nav-link {\n  background: #154c6b8a;\n  border-radius: 5px;\n  margin: 0 2px;\n}\n\n.widget-text-heading {\n  text-shadow: 3px 3px 5px rgba(0, 0, 0, 0.7);\n}\n.home-col {\n  margin-bottom: 3rem;\n  line-height: 1.5rem;\n}\n\n\n@media (min-width: 992px) {\n  .home-col {\n    width: 30%;\n  }\n}\n\n.react-calendar__tile--now {\n  background: #e5f0f4;\n}\n\n.rows_count {\n  line-height: 2.2rem;\n  color: #737675;\n}\n\n.locality-info{\n  display: flex;\n  gap: 4rem;\n   \n}\n\n.locality-container{\n  margin-top: 20px;\n  color: #3e6791;\n  padding-left: 8rem;\n  padding-right: 8rem;\n  margin-left: 10%;\n  margin-right: 10%;   \n}\n\n.circleItem{\n  background: lightblue;\n  border-radius: 50%;\n  width: 25px;\n  height: 25px;\n  vertical-align: middle;\n}\n\n.cubeItem{\n  background: lightblue;\n  width: 25px;\n  height: 25px;\n  vertical-align: middle;\n}\n\n.inner-locality-info{\n   display: flex; \n  flex-direction: column;\n  align-items: flex-start; \n  width: \"50%\";\n}\n\n\n@media (max-width: 768px) {\n  .locality-info {\n    flex-direction: column;\n    align-items: center;\n    text-align: center; \n  }\n\n  .locality-container{\n    margin-top: 20px;\n    color: #3e6791;\n    padding-left: 0rem;\n    padding-right: 0rem;\n    margin-left: 0%;\n    margin-right: 0%;   \n  }\n\n  .inner-locality-info{\n    display: flex; \n   flex-direction: column;\n   align-items: flex-start; \n   width: \"80%\";\n   padding: 0 20px 0 20px;\n }\n\n  .image-locality{\n    width: 100%;\n    object-fit: contain;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
